import { useCallback } from 'react';
import api from 'api';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from './useGetMixpanelProps';
import {
  ListingShareInitiatedEventProps,
  ListingShareMode,
} from 'models/MixpanelEvents';

type TrackShareInitiatedParams = {
  listingId: string;
  listingName: string;
};

export default function useTrackShareInitiated({
  listingId,
  listingName,
}: TrackShareInitiatedParams) {
  const getMixpanelProps = useGetMixpanelProps();

  return useCallback(
    (listingShareMode: ListingShareMode, peopleCount?: number) => {
      mixpanelService.listingShareInitiated(
        getMixpanelProps({
          listingId,
          listingName,
          listingShareMode,
        }) as ListingShareInitiatedEventProps,
      );

      api.portfolio.seller.trackListingShare(listingId, {
        sharingModus: listingShareMode,
        ...(peopleCount && { peopleCount }),
      });
    },
    [listingId, listingName, getMixpanelProps],
  );
}
